export enum Portal {
  Case = 'Case',
  Appeal = 'Appeal',
  Funder = 'Funder',
  Student = 'Student',
  Admin = 'Admin',
}

export const PORTAL_ROLES: { [portal: string]: Array<string> } = {
  [Portal.Case]: ['CaseManager', 'CaseTeamLead'],
  [Portal.Appeal]: ['AppealManager', 'AppealTeamLead'],
  [Portal.Funder]: ['FunderAdmin'],
  [Portal.Student]: [],
  [Portal.Admin]: [],
};
